import { render, staticRenderFns } from "./PcCommerce.vue?vue&type=template&id=aa2c9020&scoped=true&"
import script from "./PcCommerce.vue?vue&type=script&lang=js&"
export * from "./PcCommerce.vue?vue&type=script&lang=js&"
import style0 from "./PcCommerce.vue?vue&type=style&index=0&id=aa2c9020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2c9020",
  null
  
)

export default component.exports